// extracted by mini-css-extract-plugin
export default {"wrapper":"icon_wrapper__o9T5a","pointer":"icon_pointer__q8K4-"};